import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
@Component({
  selector: 'tekman-math',
  templateUrl: './math.component.html',
})
export class MathComponent implements OnInit, OnChanges {
  @Input() mathFormula: string;

  ngOnInit(): void {
    this.renderMath();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['mathFormula']) {
      this.renderMath();
    }
  }

  private renderMath() {
    if (window.MathJax) {
      const node = document.getElementById('mathContent');
      window.MathJax.typesetClear([node]);
      window.MathJax.startup.promise.then(() => {
        window.MathJax.typesetPromise();
      });
    }
  }
}
